<script setup lang="ts">

interface IBadge {
  type: "success" | "info" | "warning" | "danger";
  title: string;
}

const props = withDefaults(
    defineProps<IBadge>(),
    {
      type: "info",
      title: "",
    }
)
</script>

<template>
  <div class="c-cu-badge" :class="type">
    {{ title }}
  </div>
</template>

<style scoped lang="scss">
.c-cu-badge {
  padding: 3px 7px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  width: fit-content;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  &.danger {
    background: var(--color-red-light);
    color: var(--color-red);
  }

  &.success {
    //background: var(--color-cyan);
    color: var(--color-green);
  }
}
</style>